// extracted by mini-css-extract-plugin
module.exports = {"searchMatchedTag":"styles_searchMatchedTag__24s2Z"};